import React, {Component} from "react";
import {connect} from "react-redux";
import {withRouter} from 'react-router-dom';
import {toPercentage, numberWithCommas} from "../../helpers/formatters";
import {VIEWS} from "../../helpers/consts";
import {setStatsStateAction} from "./../../actions/SettingsAction";
import StatsItem from "./StatsItem";

import "./StatsBox.css";
import SVGIcon from "../svg/SVGIcon";

class StatsBox extends Component {

  constructor(props) {
    super(props);
    this.toggleOpen = this.toggleOpen.bind(this);
  }

  toggleOpen() {
    const {open, setStatsState} = this.props;
    setStatsState(!open);
  }

  render() {
    const {open, hashParts} = this.props;
    const selected = hashParts;
    const items = [];

    //EU view
    if(selected.view === VIEWS.EMPLOYMENT){
      items.push({icon: 'growth', title: "+2.7%", subtitle: 'Potential net job growth'});
      items.push({icon: 'portfolio', title: "75%", subtitle: "Employment rate 2030"});
      items.push({icon: 'chart', title: "5 p.p.", subtitle: "Employment rate change 2018-30"});
    }

    //Occupations view
    if (selected.view === VIEWS.OCCUPATIONAL) {
      const {selectedOccupation, iscoData} = this.props;
      if (!selectedOccupation || !iscoData) {
        return '';
      } else {
        const occ = iscoData.find(isco => isco.isco_2_id === selectedOccupation.id);
        items.push({icon: 'people', title: numberWithCommas(Math.round(occ.employment_2018)), subtitle: 'Total employment 2018'});
        items.push({icon: 'lady', title: toPercentage(occ.employment_share_2018, 1) + '%', subtitle: "Occupational share 2018"});
        items.push({icon: 'portfolio', title: toPercentage(occ.net_job_change_2018_30_in_percent, 1) + '%', subtitle: "Net job growth 2018 - 30"});
      }
    }

    //Cluster view
    if(selected.view === VIEWS.REGIONAL_CLUSTER){
      const {clustersData, regionData, selectedCluster, selectedRegion} = this.props;
      if (selectedCluster){
        if (!clustersData){
          return '';
        } else {
          const cluster = clustersData.find(cd => cd.cluster_id === selectedCluster.id);
          const isAvgCluster = selectedCluster.id===14;
          if (isAvgCluster){
            return '';
          }
          items.push({icon: 'marker', title: cluster.number_of_regions_within_cluster, subtitle: 'of 1095 regions'});
          items.push({icon: 'people', title: toPercentage(cluster.share_of_eu_population_within_cluster_2018_in_share, 1) + '%', subtitle: 'Share of EU population in the cluster'});
          items.push({icon: 'portfolio', title: toPercentage(cluster.share_of_positive_job_growth_2018_30, 1) + '%', subtitle:'Share of positive job growth (2018-30)'});
        }
      } else if (selectedRegion){
        if (!regionData) {
          return '';
        } else {
          const region = regionData.find(cd => cd.id === selectedRegion.id);
          items.push({icon: 'marker', title: region.cluster_name, subtitle: 'Respective cluster'});
          items.push({icon: 'people', title: numberWithCommas(region.nuts_3_region_population_2018_in_thousands), subtitle: 'Population in thousands, 2018'});
          items.push({icon: 'portfolio', title: toPercentage(region.net_job_change_2018_30,1)+'%', subtitle: 'Net job growth, 2018-30'});
        }
      }
    }

    //No items, no box
    if (items.length === 0){
      return '';
    }

    const title = open?"Statistical data":"Click to see statistical data";

    const iconName = open?"down":"up";

    return (
      <div id="fow-stats-box" className={open ? 'fow-stats-box-open' : 'fow-stats-box-closed'}>
        <div id="fow-stats-box-inner">
          <div className="fow-stats-box-title-items">
            <h3 onClick={this.toggleOpen} className="fow-stats-box-title fow-font-text fow-font-size-md">
              <div id="fow-stats-action">
                <span><SVGIcon name={iconName} strokeWidth="3" height="20" width="20" stroke="#000" fill="transparent" /></span>
              </div>
              <SVGIcon className="fow-mobile-arrows" name="down" width="20" stroke="#000" />
              {title}
              <SVGIcon className="fow-mobile-arrows" name="down" width="20" stroke="#000" />
            </h3>
          </div>
          <div className="fow-stats-box-items">
            {items.map((d,ix) =>
              <StatsItem key={ix} icon={d.icon} title={d.title} subtitle={d.subtitle} />
            )}
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    hashParts: state.settings.hashParts,
    iscoData: state.db.data.dimensions.isco ? state.db.data.dimensions.isco : false,
    clustersData: state.db.data.dimensions.clusters ? state.db.data.dimensions.clusters : false,
    regionData: state.db.data.facts.nuts3 ? state.db.data.facts.nuts3 : false,
    selectedCluster: state.settings.map["Clusters"],
    selectedOccupation: state.settings.map["Occupations"],
    selectedRegion: state.settings.map["Regions"],
    open: state.settings.statsOpen
  };
};
const mapDispatchToProps = dispatch => ({
  setStatsState: open => dispatch(setStatsStateAction(open)),
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(StatsBox));
